import { createSelector } from 'reselect'

import { currentInviteeSelector } from 'selectors/current_invitee'

export const inviteeSelector = (state) => {
  if (Object.keys(state.scheduling.invitee).length !== 0) {
    return state.scheduling.invitee
  }
  if (currentInviteeSelector(state) && (Object.keys(currentInviteeSelector(state)).length !== 0)) {
    return currentInviteeSelector(state)
  }
  return state.invitee || {}
}

export const legacyInviteeSelector = (state) => {
  if (Object.keys(state.scheduling.invitee).length !== 0) {
    return state.scheduling.invitee
  }
  return state.invitee || {}
}

export const uuidSelector = createSelector(
  inviteeSelector,
  ({ uuid }) => uuid
)

export const emailSelector = createSelector(
  inviteeSelector,
  ({ email }) => email
)

export const emailAsUsernameSelector = createSelector(
  inviteeSelector,
  ({ email }) => (typeof email === 'string' ? email.split('@')[0] : '')
)

export const timezoneSelector = createSelector(
  inviteeSelector,
  ({ timezone }) => timezone
)

export const nameSelector = createSelector(
  inviteeSelector,
  (invitee) => (
    invitee.full_name
    || [invitee.first_name, invitee.last_name].filter(Boolean).join(' ')
  )
)

export const timeNotationSelector = createSelector(
  inviteeSelector,
  (invitee) => invitee.time_notation
)

export const pendingPhoneVerificationSelector = createSelector(
  inviteeSelector,
  (invitee) => invitee.pending_phone_verification === true
)
